import { useState, useEffect } from 'react'

export function useIsScrolling(): boolean {
  const [isScrolling, setIsScrolling] = useState(false)

  useEffect(() => {
    document.onscroll = () => {
      if (window.scrollY === 0) setIsScrolling(false)
      if (window.scrollY !== 0 && !isScrolling) setIsScrolling(true)
    }
  }, [isScrolling, setIsScrolling])

  return isScrolling
}
